@if (promotedItinerariesItems().length) {
    <div class="mx-auto grid max-w-screen-xl grid-cols-6 gap-12 px-10">
        <!-- Heading -->
        <div class="col-span-6 text-left md:text-center">
            <h2 class="text-left md:text-center">Ready for an adventure?</h2>
        </div>

        @for (
            itinerary of promotedItinerariesItems();
            track itinerary.urlSlug
        ) {
            <div
                class="col-span-6 h-full w-full items-center md:col-span-3 lg:col-span-2">
                <app-trips-itinerary-card
                    [trip]="destination()?.contentfulTrip"
                    [itinerary]="itinerary">
                </app-trips-itinerary-card>
            </div>
        }
    </div>
}
